var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoCheckWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.59202 1.46049C9.84632 1.13353 9.78742 0.662323 9.46046 0.40802C9.1335 0.153718 8.66229 0.212619 8.40799 0.539579L4.40099 5.69144C4.31189 5.806 4.14429 5.82086 4.03641 5.72378L1.50173 3.44256C1.19385 3.16547 0.71963 3.19043 0.442536 3.49831C0.165441 3.80619 0.190401 4.28041 0.498283 4.5575L3.03296 6.83872C3.78809 7.51833 4.9613 7.41427 5.58502 6.61235L9.59202 1.46049Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCheckWhite);
export default __webpack_public_path__ + "static/media/ico_check_white.6f711d750eedd81151bcce8a8b51be0b.svg";
export { ForwardRef as ReactComponent };